exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".el-row[data-v-3b1dd70c]{margin-bottom:20px;&:last-child{margin-bottom:0}}.el-col[data-v-3b1dd70c]{border-radius:4px}.grid-content[data-v-3b1dd70c]{border-radius:4px;min-height:30px;color:#d9001b}.row-bg[data-v-3b1dd70c]{padding:7px 0;background:#fef0f0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3b1dd70c","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/clue/allocation.vue
// module id = 1865
// module chunks = 0